<template>
  <section class="card education-section">
    <h4
      class="card-header collapse-bar"
      data-toggle="collapse"
      href="#education-details"
      role="button"
      aria-expanded="false"
      aria-controls="education-details"
      @click="animateIcon"
    >
      <!-- click action to collapse-->
      <transition name="fade" mode="out-in">
        <span class="collapse-icon" v-if="isCollapsed" key="closed">
          <font-awesome-icon :icon="['fas', 'angle-double-up']" />
        </span>
        <span class="collapse-icon" v-else key="open">
          <font-awesome-icon :icon="['fas', 'angle-double-down']" />
        </span>
      </transition>
      Education
    </h4>
    <div id="education-details" class="collapse">
      <div
        class="card-body education"
        v-for="education in educationData"
        :key="education.educationId"
      >
        <h6 class="card-title">{{ education.institution }}</h6>
        <div>{{ education.area }}</div>
        <div>{{ education.degree }}, {{ education.graduationYear }}</div>
      </div>
      <a href="#education-details" class="btn btn-link float-right">To Top</a>
    </div>
  </section>
</template>

<script>
import { animateIconMixin } from './animateIconMixin'
import { getEducation } from '../../db'
export default {
  name: 'Education',
  mixins: [animateIconMixin],
  data() {
    return {
      educationData: [],
    }
  },
  mounted() {
    getEducation().then((vals) => {
      this.educationData = vals
    })
  },
}
</script>
